import React from 'react';
import { Tabs } from 'antd';
import { updateFormField } from 'store/forms/actions';
import { useDispatch } from 'react-redux';

const { TabPane } = Tabs;

const CustomTabsTimelineSub = ({ tabs, tabProps, customClass,current, setCurrent,subtabs, currentSubTab, ...rest }) => {
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState(current);//useState(tabs[0].id);
  // const onChange = key => setActiveTab(key);
  const onChange = key => dispatch(
    updateFormField({
      group: 'carrier',
      key:'currentSubTab',
      value: Number(key) ,
    })
  );

  // useEffect(()=> {
  //   setActiveTab(current)
  // },[current])

  return (
    <div className={`${customClass}`}>
      <Tabs
        defaultActiveKey={currentSubTab}
        activeKey={currentSubTab.toString()}
        onChange={onChange}
        className={`fullwidth-tabs`}
        {...rest}
      >
        {tabs.map(({ label, id, Component}, index) => (
          <TabPane 

            key={index} 

            tab={ 
              [ <div id={id} className='tab-timeline'>
                  <div id={id} className='tab-timeline-label'>
                    {label}
                  </div>
              </div>
              ]
            }
          >
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimelineSub;
